import { create } from 'zustand';
import { UIState } from '../types';

interface UIStore extends UIState {
  toggleSidebar: () => void;
  toggleRightPanel: () => void;
  setSidebarOpen: (open: boolean) => void;
  setRightPanelOpen: (open: boolean) => void;
  setCurrentThread: (threadId?: string) => void;
  setSelectedFolder: (folderId?: string) => void;
  setIsMobile: (isMobile: boolean) => void;
}

export const useUIStore = create<UIStore>((set) => ({
  sidebarOpen: true,
  rightPanelOpen: false,
  currentThread: undefined,
  selectedFolder: undefined,
  isMobile: false,

  toggleSidebar: () =>
    set((state) => ({ sidebarOpen: !state.sidebarOpen })),

  toggleRightPanel: () =>
    set((state) => ({ rightPanelOpen: !state.rightPanelOpen })),

  setSidebarOpen: (open: boolean) =>
    set({ sidebarOpen: open }),

  setRightPanelOpen: (open: boolean) =>
    set({ rightPanelOpen: open }),

  setCurrentThread: (threadId?: string) =>
    set({ currentThread: threadId }),

  setSelectedFolder: (folderId?: string) =>
    set({ selectedFolder: folderId }),

  setIsMobile: (isMobile: boolean) =>
    set({ isMobile }),
}));
